import React  from 'react';
import styled from 'styled-components';
import CarouselMain from './CarouselMain';
import { Link } from 'react-router-dom';
const Styles = styled.div`
  margin: 2rem var(--universal-pad) 0;
  isolation: isolate;
  .top {
      display: flex;
      margin: 0 0 1rem;
      justify-content: space-between;
      text-decoration: none;
      color: inherit;
      .title {
          font-size: 1.25rem;
          font-weight: 600;
      }
  }
  .container {
    padding-bottom: 2.5rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .continent {
    flex-grow: 1;
    min-width: 140px;
    background-color: var(--n-grey-0);
    padding: 1rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--border-radius-3);
    position: relative;
    text-decoration: none;
    color: inherit;
    &::before {
        content: "";
        z-index: -1;
        position: absolute;
        inset: -1px;
        background: linear-gradient(180deg, #E5E5E5 0%, #E5E5E500 100%);
        border-radius: calc(var(--border-radius-3) + 1px);
    }
    box-shadow: 0px 23px 40px -13px #00000014;

  }
  @media screen and (max-width: 850px) {
    /* margin: 2rem 0 0; */
  }
`
export default function Continents26 (props){
  const {data: dataRaw, list= [], lan} = props;
  const data = JSON.parse(dataRaw);
  return (
    <Styles>
      <div className='top'>
          <h2 className='title'>
              {data.title}
          </h2>
      </div>
      <div className='container'>
        {
          list.map((v, i) => {
            return (
              <Link className='continent' to={`/${lan.filename}/tour/${v.Continent_Url}`} key={i}>
                {(lan.filename === "fa") ? v.Continent_FaName : v.Continent_EnName}
              </Link>
            )
          })
        }
      </div>
    </Styles>
  )
}

